const getEmbedUrl = (videoLink, provider) => {
  if (!videoLink || !provider) return null;

  if (provider === "YOUTUBE") {
    if (videoLink.includes("youtube.com/embed/")) {
      return videoLink;
    }
    // Handle watch URLs (e.g., "https://www.youtube.com/watch?v=ezUYAm7VrHA")
    if (videoLink.includes("youtube.com/watch?v=")) {
      const videoId = videoLink.split("v=")[1]?.split("&")[0];
      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    }
    // Handle short URLs (e.g., "https://youtu.be/ezUYAm7VrHA?feature=shared")
    if (videoLink.includes("youtu.be/")) {
      const videoId = videoLink.split("youtu.be/")[1]?.split("?")[0];
      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    }
  } else if (provider === "VIMEO") {
    // Handle full embed URLs (e.g., "https://player.vimeo.com/video/1086108830")
    if (videoLink.includes("player.vimeo.com/video/")) {
      const videoId = videoLink
        .split("player.vimeo.com/video/")[1]
        ?.split("?")[0];
      return videoId ? `https://player.vimeo.com/video/${videoId}` : null;
    }
    // Handle video ID only (e.g., "1086063904") or partial URLs
    const videoId = videoLink.match(/^\d+$/)
      ? videoLink
      : videoLink.split("/").pop()?.split("?")[0];
    if (videoId && /^\d+$/.test(videoId)) {
      return `https://player.vimeo.com/video/${videoId}`;
    }
  }

  return null;
};

export default getEmbedUrl;
